/**
 * Единый разбор skillGroups с вакансии / API / кэша:
 * массив или JSON-строка; пустой массив и битый JSON → undefined.
 * Согласовано с модалкой фильтров (не показываем пустые группы как валидные).
 */
export type SkillGroupRaw = { type?: unknown; skills?: unknown };

export function parseSkillGroupsRaw(raw: unknown): SkillGroupRaw[] | undefined {
  if (raw == null) return undefined;
  if (Array.isArray(raw)) {
    return raw.length > 0 ? (raw as SkillGroupRaw[]) : undefined;
  }
  if (typeof raw === 'string' && raw.trim()) {
    try {
      const parsed: unknown = JSON.parse(raw);
      return Array.isArray(parsed) && parsed.length > 0 ? (parsed as SkillGroupRaw[]) : undefined;
    } catch {
      return undefined;
    }
  }
  return undefined;
}
